import { createAlert } from '../alert.js?vue3';
import { initRails } from '../lib/utils/rails_ujs.js?vue3';
import { getParameterByName } from '~/lib/utils/url_utility';
import { __, sprintf } from '~/locale';
import { waitForElement } from '~/lib/utils/dom_utils';

const PARAMETER_NAME = 'leave';
const PROJECT_LEAVE_LINK_SELECTOR = '.js-leave-link';
const GROUP_LEAVE_LINK_SELECTOR = '#group-more-action-dropdown .js-leave-link';

export const NAMESPACE_TYPES = {
  GROUP: 'group',
  PROJECT: 'project',
};

export default async function leaveByUrl(namespaceType) {
  if (!namespaceType) throw new Error('namespaceType not provided');

  const param = getParameterByName(PARAMETER_NAME);
  if (!param) return;

  initRails();

  const LEAVE_LINK_SELECTOR =
    namespaceType === NAMESPACE_TYPES.GROUP
      ? GROUP_LEAVE_LINK_SELECTOR
      : PROJECT_LEAVE_LINK_SELECTOR;

  try {
    const leaveLink = await waitForElement(LEAVE_LINK_SELECTOR);
    leaveLink.click();
  } catch (error) {
    createAlert({
      message: sprintf(__('You do not have permission to leave this %{namespaceType}.'), {
        namespaceType,
      }),
    });
  }
}
